// Accent- and case-insensitive text search (Água = agua).
export const norm = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
export const matches = (text, q) => !norm(q) || norm(text).includes(norm(q));
